<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <header>
    <div class="headline">
      @if (labDip?.id) {
        <h1>Lab Dip {{ labDip?.labDipNumber }}</h1>
      } @else {
        <h1>{{ 'LabDip_New' | translateWF: 'New Lab Dip' }}</h1>
      }
    </div>
    <div class="buttons">
      @if (canEdit()) {
        <p-button [label]="'Common_Save' | translateWF: 'Save'" (click)="onSubmit()" [disabled]="formGroup.invalid" />
      }
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <!-- Select status section -->
    <section>
      <form>
        <div class="input-status">
          <label for="status">{{ 'LabDip_Status' | translateWF: 'Status' }}</label>
        </div>
        <div class="input-status">
          <label for="name">{{ 'LabDip_Name' | translateWF: 'Name' }}</label>
          <input id="name" type="text" pInputText [formControl]="name" />
        </div>
      </form>
    </section>

    <!-- list color section -->
    @if (colorDataInfo) {
      <section>
        <div class="page__title">
          <div class="page__title_container">
            <h2>{{ 'LabDip_Color' | translateWF: 'Color' }}</h2>
          </div>
        </div>
        <app-card-color [color]="colorDataInfo" />
      </section>
    }

    <section class="">
      <div class="page__title">
        <div class="page__title_container">
          @if (labDip && labDip.processRefWithStepValues) {
            <h2>{{ 'LabDip_Processes' | translateWF: 'Processes' }} ({{ labDip.processRefWithStepValues.length }})</h2>
          } @else {
            <h2>{{ 'LabDip_Processes' | translateWF: 'Processes' }} (0)</h2>
          }
          <div class="page__title_buttons flex gap-[1rem]">
            @if (showSortProcessesInput) {
              <div class="selection-adding-process gap-[1rem]">
                <!-- <cs-typeahead
                  [formControl]="processToAdd"
                  fieldToDisplay="name"
                  [options]="processTypeAhead"
                /> -->
                <p-button
                  [label]="'LabDip_Select' | translateWF: 'Select'"
                  [disabled]="processToAdd.invalid"
                  (click)="addProcess(processToAdd.value!.processId); showSortProcessesInput = !showSortProcessesInput"
                />
              </div>
            }
            @if (canEdit()) {
              <p-button
                [label]="'LabDip_Add_Process' | translateWF: 'Add Process'"
                icon="pi pi-plus"
                [disabled]="!canEdit()"
                (click)="showSortProcessesInput = !showSortProcessesInput"
              />
            }
          </div>
        </div>
      </div>

      <div class="list-processes">
        <div class="list-processes__header">
          <div>
            <p>{{ 'LabDip_Process_ID' | translateWF: 'Process ID' }}</p>
          </div>
          <div>
            <p>{{ 'LabDip_Process_Name' | translateWF: 'Name Process' }}</p>
          </div>
        </div>

        @for (process of processes; track $index) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> {{ process.processId }}</mat-panel-title>
              <mat-panel-description>
                {{ getProcessName(process.processId) }}
                @if (canEdit()) {
                  <p-button icon="pi pi-trash" (click)="removeProcess($index); $event.stopPropagation()" />
                }
              </mat-panel-description>
            </mat-expansion-panel-header>

            @for (parameter of process.processParameters; track $index) {
              <div class="group-parameter">
                @if (parameter.parameter) {
                  <label for=""> {{ parameter.parameter.name }} </label>
                }
                @if (!getParameter(process.processId, null, parameter.parameterRef)?.hasMultipleValues) {
                  <input type="text" [(ngModel)]="parameter.values[0]" />
                  <p class="error" *ngIf="getParameterValidation(parameter.values[0], undefined, parameter.parameterRef)">
                    {{ getParameterValidation(parameter.values[0], undefined, parameter.parameterRef) }}
                  </p>
                }
              </div>
            }

            <!-- iterable content about process inputs -->
            <div class="">
              @for (step of process.stepWithParameters; track $index) {
                <!-- header-for-description-inputs -->
                <div
                  class="header-inputs-description"
                  [ngClass]="{
                    ' header-inputs-description--selected': step.excluded,
                  }"
                >
                  <div class="header-inputs-description__item">
                    <p>{{ 'LabDip_Exclude' | translateWF: 'Exclude' }}</p>
                  </div>
                  <div class="header-inputs-description__item">
                    <p>{{ 'LabDip_Step_ID' | translateWF: 'Step ID' }}</p>
                  </div>
                  <div class="header-inputs-description__item">
                    <p>{{ 'LabDip_Step_Name' | translateWF: 'Step Name' }}</p>
                  </div>
                  @for (param of step.parameterAndValues; track $index) {
                    <div class="header-inputs-description__item">
                      <p>
                        {{ getParameter(null, step.stepId, param.parameterRef)?.parameter?.name }}
                      </p>
                    </div>
                  }
                </div>

                <!-- content-dynamic-inputs -->
                <div class="content-dynamic" [ngClass]="{ 'content-dynamic--selected': step.excluded }">
                  <div class="content-dynamic__input__checkbox">
                    <label for="" class="input-checkbox">
                      <input [(ngModel)]="step.excluded" type="checkbox" class="" />
                    </label>
                  </div>
                  <div class="content-dynamic__input">
                    <p>
                      {{ step.stepId }}
                    </p>
                  </div>
                  <div class="content-dynamic__input">
                    <p>{{ step.step?.name }}</p>
                  </div>

                  @for (param of step.parameterAndValues; track $index) {
                    <div class="content-dynamic__input">
                      @if (!getParameter(null, step.stepId, param.parameterRef)?.hasMultipleValues) {
                        <input type="text" [(ngModel)]="param.values[0]" />
                        <p class="error text-sm" *ngIf="getParameterValidation(param.values[0], undefined, param.parameterRef)">
                          {{ getParameterValidation(param.values[0], undefined, param.parameterRef) }}
                        </p>
                      } @else {
                        <p-button label="Values" icon="pi pi-pencil" (click)="openStepValuesModal(process.processId, step.stepId, param.parameterRef)" />
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      </div>
    </section>
  </div>
</main>
